var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "section",
    { staticClass: "pending-actions-container" },
    [
      _setup.ListStatus.LOADING === _setup.status
        ? _c(_setup.SpinnerLayerComponent, { staticClass: "spinner-layer" })
        : _c("div", { staticClass: "pending-actions" }, [
            _c("header", [_vm._v(_vm._s(_setup.texts.title))]),
            _setup.ListStatus.OK === _setup.status
              ? _c(
                  "div",
                  { staticClass: "items-row" },
                  _vm._l(_setup.widgetList, function (action, index) {
                    return _c(_setup.DashboardActionItemComponent, {
                      key: `action-${index}`,
                      attrs: { action: action },
                    })
                  }),
                  1
                )
              : _vm._e(),
            _setup.ListStatus.EMPTY === _setup.status
              ? _c("section", { staticClass: "no-actions-container" }, [
                  _c("span", {
                    class: [_setup.noDataIcon, "lf-icon__xl", "no-data-icon"],
                  }),
                  _c(
                    "div",
                    { staticClass: "texts" },
                    [
                      _c("p", { staticClass: "no-data-text" }, [
                        _vm._v(_vm._s(_setup.texts.noData)),
                      ]),
                      _c("i18n", {
                        staticClass: "link-text",
                        attrs: { path: _setup.path, tag: "div" },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "link",
                              fn: function () {
                                return [
                                  _c(
                                    "router-link",
                                    {
                                      staticClass: "actions-link",
                                      attrs: { to: _setup.actionsListURL },
                                    },
                                    [_vm._v(_vm._s(_setup.texts.newActions))]
                                  ),
                                ]
                              },
                              proxy: true,
                            },
                          ],
                          null,
                          false,
                          3042921795
                        ),
                      }),
                    ],
                    1
                  ),
                ])
              : _vm._e(),
            _setup.ListStatus.ERROR === _setup.status
              ? _c("section", { staticClass: "no-actions-container" }, [
                  _c("span", {
                    class: [_setup.errorIcon, "lf-icon__xl", "no-data-icon"],
                  }),
                  _c("div", { staticClass: "texts" }, [
                    _c("p", { staticClass: "no-data-text" }, [
                      _vm._v(_vm._s(_setup.texts.loadError)),
                    ]),
                  ]),
                ])
              : _vm._e(),
          ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }